import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'dam-not-registered',
  templateUrl: './not-registered.component.html',
  standalone: false,
//  styleUrls: ['./not-registered.component.scss']
})
export class NotRegisteredComponent implements OnInit {
  @Input() type: string;
  @Input() track: any;
  @Input() recoveryInProgress: boolean;
  @Input() autoRegEmail: string;
  @Output() register = new EventEmitter();
  @Output() back = new EventEmitter();

  constructor() {}

  ngOnInit() {}

  onRegister() {
    this.register.emit();
  }

  onBack() {
    this.back.emit();
  }
  get isAutoreg() {
    return this.type === 'autoreg'? true : false;
  }
}
